const showOutcomeAction = (payload) => ({ type: "SHOW_OUTCOME", payload });
const hideOutcomeAction = (payload) => ({ type: "HIDE_OUTCOME", payload });

export const showOutcome = (outcome_slug) => {
  return (dispatch, getState) => {
    const state = getState();
    $.ajax({
      url: `/organizations/${state.static.organization_name}/users/show_outcome`,
      method: "PATCH",
      data: {
        outcome_slug: outcome_slug,
      },
      success: (response) => {
        dispatch(showOutcomeAction(outcome_slug));
      },
    });
  };
};
export const hideOutcome = (outcome_slug) => {
  return (dispatch, getState) => {
    const state = getState();
    $.ajax({
      url: `/organizations/${state.static.organization_name}/users/hide_outcome`,
      method: "PATCH",
      data: {
        outcome_slug: outcome_slug,
      },
      success: (response) => {
        dispatch(hideOutcomeAction(outcome_slug));
      },
    });
  };
};
